/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { ToolOptions, ModalBody, Wrap, ChangeCursor } from './styles';

import geoAlert from 'services/utils/alert';
import geoConfirm from 'services/utils/confirm';
import Coordinate from 'services/utils/Coordinate';

import Marker from './assets/marker.svg';
import {
  ElipseIcon,
  LineIcon,
  MarkerIcon,
  PenIcon,
  PolygonIcon,
  CheckIcon,
  TrashIcon,
} from './components/Icons';
import toolReducer, { initialToolState } from './services/toolReducer';

import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
import featureContextMenu from '@map/services/utils/featureContextMenu';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useReducer é um hook parecido com o useState, ele permite a logica
 * de estado personalizada, para acompanhar varios pedaços de estado
 * que dependem de logia complexa o useReducer é indicado.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useReducer, useCallback } from 'react';
import SimpleModal from 'views/MapView/components/SimpleModal';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';

const polylineOptions = {
  vertexDistances: {
    enable: true,
    position: 'centered',
    tooltip: true,
  },
  showMarkerPoints: true,
};

const polygonOptions = {
  showTempPolygon: true,
  vertexDistances: {
    enable: false,
    position: 'centered',
    tooltip: true,
  },
  showMarkerPoints: true,
};

/**
 * Função responsável por inserir pontos, linhas, poligonos e circulos no mapa, atráves
 * do cursor, podendo criar varias figuras contento a medida de cada uma, nescessario 
 * clicar no ponto inicial após fazer a figura para que a mesma fique salva no mapa.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @returns um menu com as opções das figuras apos clicar em uma delas o cursor do mouse 
 * muda para uma mira de bola com exeção do ponto que o cursor vira um ponto. Possibilitando
 * fazer figuras por todo o mapa e nela contento as medidas da area selecionada.
 */
export const Draw = ({ mapContext, isActive, setIsActive }) => {
  const [toolState, toolDispatch] = useReducer(toolReducer, initialToolState);

  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);
  useEffect(() => {
    if (!isActive) setAnchorToolOptions(null);
  }, [isActive]);

  const mapCtx = useMap(); // hook personalizado para gerenciar a comunicação dos componentes com o mapa.
  const { getElement, activeModule } = useModule();
  const { map } = mapCtx; // hook personalizado para gerenciar a comunicação dos componentes com o mapa.


  const handleSelectItem = (item) => {
    toolDispatch({ type: 'selectOrToogleActiveItem', payload: item });
  };

  const contextMenuListener = (event, payload) => {    
    if(event === 'ctxmenu:featureremoved') {
      toolDispatch({
        type: 'deleteFeature',
        payload: payload.featureDeleted._leaflet_id,
      })
        return payload;
      }   
  };

  const checkGeometryLimit = useCallback(
    (layerToCheck) => {
      let geometryLimit = getElement(Draw.properties.id)?.configuracao
        .geometryLimit;
      if (geometryLimit) {
        let layerArea = turf.area(layerToCheck);
        let intersectResult = turf.intersect(layerToCheck, geometryLimit);
        let intersectArea = intersectResult ? turf.area(intersectResult) : 0;
        if ((100 / layerArea) * intersectArea < 90) {
          geoAlert({
            message:
              getElement(Draw.properties.id)?.configuracao
                .geometryLimitMessage ||
              'A geometria deve estar contida dentro do limite!',
          });
          return false;
        }
      }
      return true;
    },
    [getElement]
  );

  // Handle de listeners create e drawstart do geoman
  // ? Migrar para o useReducer
  useEffect(() => {
    // Função executada ao finalizar o desenho
    const onCreateFeature = (e) => {
      if (e.shape === 'Polygon' && e.layer._latlngs[0].length <= 2) {
        e.layer.remove();
      } else {
        checkGeometryLimit(e.layer.toGeoJSON());
        // Valida a edição da feição
        e.layer.on('pm:update', ({ layer }) => {
          checkGeometryLimit(layer.toGeoJSON());
        });
        // Abre menu popup com as ações para a feição
        e.layer.on('contextmenu', (event) => {
          event.originalEvent.preventDefault();

          featureContextMenu({
            selectedLayer: e.layer,
            anchorPosition: {
              mouseX: event.originalEvent.clientX - 2,
              mouseY: event.originalEvent.clientY - 4,
            },
            listener: contextMenuListener,
            features: toolState.features,
            map,
          });
        });

        // Habilita a edição da feição
        e.layer.on('dblclick', (event) => {
          map.doubleClickZoom.disable();
          e.layer.pm.toggleEdit();
          setTimeout(() => map.doubleClickZoom.enable(), 300);
        });

        // Exibe as medidas da feição
        if (e.shape !== 'Marker') {
          e.layer.showMeasurements(
            e.shape === 'Line' ? polylineOptions : polygonOptions
          );
        } else {
          let coordsDMS = Coordinate.convertDDToDMS([e.layer.getLatLng().lat, e.layer.getLatLng().lng]);          
          let lat = coordsDMS[0];
          let lng = coordsDMS[1];
          e.layer.unbindTooltip();
          e.layer.bindTooltip(
            `<div>
              Latitude: ${lat}<br>
              Longitude: ${lng}
            </div>`,
            {
                direction: 'center',
                opacity: 1,        
                permanent: true,
                interactive: true,
                className: 'leaflet-transparent-tooltip',
                offset: [0, -40],                
            }
          );
        }
        toolDispatch({ type: 'selectFeature', payload: e.shape });
        toolDispatch({
          type: 'addFeature',
          payload: e.layer,
        });
      }
      toolState.activeItem !== 'Marker' &&
        toolDispatch({ type: 'selectOrToogleActiveItem', payload: null });
    };

    //método para retirar último vertice ao pressionar o ctrl+Z
    const removeLastVertex = ({ workingLayer, shape }) => {
      //verifica se a feição é linha ou poligono
      if(shape === 'Polygon' || shape === 'Line'){

        let mouseX;
        let mouseY;

        document.addEventListener("mousemove", function(event) {
          mouseX = (event.clientX); // Coordenada X do mouse em relação à janela do navegador.
          mouseY = (event.clientY); // Coordenada Y do mouse em relação à janela do navegador.
        });
        
        const handleKeyDown = (event) => {
          // Verifique se a tecla "Ctrl" (ou "Cmd" em macOS) está pressionada.
          const ctrlKey = event.ctrlKey || event.metaKey; // Ctrl no Windows/Linux, Cmd no macOS
        
          // Verifique se a tecla "Z" está pressionada.
          if (ctrlKey && event.key === 'z' ) {
            //método para simular o movimento do mouse para o preview da linha ficar sobre o cursor do mouse.
            const simulateMouseMovement = (pointActual)=>{
              // Crie um evento de movimento do mouse personalizado com coordenadas X e Y desejadas.
              const eventoMouseMove = new MouseEvent("mousemove", {
                clientX: mouseX, // Coordenada X do mouse
                clientY: mouseY, // Coordenada Y do mouse
              });
              // Despache o evento personalizado no elemento alvo.
              pointActual.dispatchEvent(eventoMouseMove);
            }
            // Verifique se há uma geometria sendo desenhada.
            if (workingLayer?._order) {
              // Verifique se a geometria tem vértices.    
              if (workingLayer._latlngs.length > 1) {
                let reference = document.querySelector('.leaflet-container');
                // Remova o último vértice da geometria.
                (workingLayer._latlngs).pop();
                // Encontre e remova o último marcador se houver.
                const markers = document.querySelectorAll('.marker-icon');
                if (markers.length > 1) {
                  let lastMarker = markers[markers.length - 1];
                  lastMarker.remove();
                  simulateMouseMovement(reference);
                }
              }
              else if(workingLayer._latlngs.length === 1){
                const markers = document.querySelectorAll('.marker-icon');
                // Remova o último vértice da geometria.
                (workingLayer._latlngs).pop();
                if (markers.length > 1) {
                  let lastMarker = markers[markers.length - 1];
                  lastMarker.remove();
                }
                handleSelectItem(null);
                handleSelectItem(shape);
              }
              if (workingLayer._latlngs.length > 0) {
                // Remova a última aresta da geometria.
                (workingLayer._parts[0]).pop();
              }
              if (workingLayer._latlngs.length > 0) {
                // Remova a informação do último vértice da geometria.
                (workingLayer._latlngInfo).pop();
              }
              if (workingLayer._latlngs.length > 0) {
                // Remova a última argola do objeto.
                (workingLayer._rings[0]).pop();
              }
            }
            // Isso evita que o navegador ou aplicativo execute a ação padrão (como retroceder no histórico).
            event.preventDefault();
          }
        }
        document.addEventListener('keydown', handleKeyDown);
      }
    }
    
    // Exibir medidas durante o desenho
    const onVertexAdded = ({ workingLayer, shape }) => {
      if (!workingLayer._measurementLayer && shape !== 'Marker') {
        workingLayer.showMeasurements(
          shape === 'Line'
            ? { ...polylineOptions, showMarkerPoints: false }
            : { ...polygonOptions, showMarkerPoints: false }
        );
      }
      workingLayer.on('pm:vertexadded', (e) => {
        e.workingLayer.updateMeasurements();
      });
      const updateMeasure = (ee) => workingLayer.updateMeasurements(ee);
      if (shape !== 'Marker') map.on('mousemove', updateMeasure);
      map.on('pm:drawend', () => map.off('mousemove', updateMeasure));
      // document.removeEventListener('keydown', handleKeyDown); 
    };

    if (isActive && toolState.activeItem) {
      let markerIcon = L.icon({
        iconUrl: Marker,
        iconSize: [22, 22],
        iconAnchor: [13, 28],
        popupAnchor: [-3, -76],
      });
      map.on('pm:create', onCreateFeature);
      map.on('pm:drawstart', onVertexAdded);
      map.on('pm:drawstart', removeLastVertex);
      map.pm.enableDraw(toolState.activeItem, {
        snappable: true,
        allowSelfIntersection: false,
        snapDistance: 0,
        finishOn: 'dblclick',
        cursorMarker: false,
        markerEditable: false,
        markerStyle: {
          icon: markerIcon,
        },
      });
    } else {
      map.pm.disableDraw();
      if (toolState.activeItem)
        toolDispatch({ type: 'selectOrToogleActiveItem', payload: null });
    }
    return () => {
      map.off('pm:create', onCreateFeature);
      map.off('pm:drawstart', onVertexAdded);
      map.off('pm:drawstart', removeLastVertex);
    };
  },[
     toolState.activeItem,
     isActive, map, 
     toolState.features, 
     getElement, 
     checkGeometryLimit
    ]);

  // Observando se a ferramenta está ativa ou se tem feature criada
  useEffect(() => {
    if (!isActive && toolState.features.length) {
      toolState.features.forEach((l) => l.remove());
      toolDispatch({ type: 'setFeatures', payload: [] });
      toolDispatch({ type: 'selectFeature', payload: null });
    } else if (isActive && !toolState.features.length) {
      toolDispatch({ type: 'selectFeature', payload: null });
    }
  }, [toolState.features, isActive]);

  return (
    <Wrap>
      {toolState.activeItem && toolState.activeItem !== 'Marker' && (
        <ChangeCursor />
      )}
      <ButtonTooltip
        tooltip={Draw.properties.alias}
        description={Draw.properties.description}
        onClick={(e) => {
          let drawTool = getElement(Draw.properties.id);          
          drawTool?.configuracao.informationalMessage !== false &&
            !isActive &&
            geoAlert({
              message: drawTool?.configuracao.message,
              configInformationalMessage: {
                optionDontShowAlertAgain: drawTool?.configuracao.optionNotShowAgain !== false,
                aliasModule: activeModule.apelido,
                toolId: Draw.properties.id,
                aliasIdentifierCookie: 'dontShowInformationMessage',
                expireDays: drawTool?.configuracao.daysToExpire,
              },
            });
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >
        <PenIcon />
      </ButtonTooltip>
      <ToolOptions open={isActive} anchorEl={anchorToolOptions}>
        {activeModule &&
          getElement(Draw.properties.id)?.configuracao.point !== false && (
            <ButtonTooltip
              tooltip="Ponto"
              onClick={() => {
                handleSelectItem('Marker');
              }}
              active={toolState.activeItem === 'Marker'}
              activeWithBgColor
              disabled={![null, 'Marker'].includes(toolState.selectedFeature)}
            >
              <MarkerIcon />
            </ButtonTooltip>
          )}
        {activeModule &&
          getElement(Draw.properties.id)?.configuracao.line !== false && (
            <ButtonTooltip
              tooltip="Linha"
              onClick={() => {
                handleSelectItem('Line');
              }}
              active={toolState.activeItem === 'Line'}
              activeWithBgColor
              disabled={![null, 'Line'].includes(toolState.selectedFeature)}
            >
              <LineIcon />
            </ButtonTooltip>
          )}
        {activeModule &&
          getElement(Draw.properties.id)?.configuracao.polygon !== false && (
            <ButtonTooltip
              tooltip="Polígono"
              onClick={() => {
                handleSelectItem('Polygon');
              }}
              active={toolState.activeItem === 'Polygon'}
              activeWithBgColor
              disabled={
                ![null, 'Polygon', 'Circle'].includes(toolState.selectedFeature)
              }
            >
              <PolygonIcon />
            </ButtonTooltip>
          )}
        {activeModule &&
          getElement(Draw.properties.id)?.configuracao.circle !== false && (
            <ButtonTooltip
              tooltip="Círculo"
              onClick={() => {
                handleSelectItem('Circle');
              }}
              active={toolState.activeItem === 'Circle'}
              activeWithBgColor
              disabled={
                ![null, 'Polygon', 'Circle'].includes(toolState.selectedFeature)
              }
            >
              <ElipseIcon />
            </ButtonTooltip>
          )}
        <hr />
        <ButtonTooltip
          tooltip="Remover todas as geometrias"
          disabled={toolState.selectedFeature === null}
          activeWithBgColor
          onClick={() => {
            handleSelectItem(null);
            geoConfirm({
              message:
                'A(s) geometria(s) será(ão) apagadas. Deseja continuar?',
              callback: (confirmed) => {
                if (confirmed) {
                  toolDispatch({
                    type: 'deleteAllFeatures',
                    payload: { silent: true },
                  });
                }
              },
            });
          }}
        >
          <TrashIcon />
        </ButtonTooltip>
        <ButtonTooltip
          tooltip="Salvar"
          disabled={toolState.selectedFeature === null}
          activeWithBgColor
          onClick={() => {
            let checkLimit = true;
            toolState.features.forEach((f) => {
              if (!checkGeometryLimit(f.toGeoJSON())) checkLimit = false;
            });

            if (checkLimit) {
              handleSelectItem(null);
              toolDispatch({ type: 'openSaveModal' });
            }
          }}
        >
          <CheckIcon />
        </ButtonTooltip>
      </ToolOptions>
      <SimpleModal
        title="Salvar Camada"
        activeWithBgColor
        open={toolState.displaySaveModal}
        onClose={() => {
          toolDispatch({ type: 'closeSaveModal' });
        }}
      >
        <ModalBody>
          <TextField
            id="layer-name"
            label="Nome da camada"
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{ maxlength: 70 }}
            value={toolState.layerNameToSave}
            onChange={(e) => {
              toolDispatch({
                type: 'setLayerNameToSave',
                payload: e.target.value,
              });
            }}
            error={Boolean(toolState.saveLayerNameError)}
            helperText={toolState.saveLayerNameError}
          />
          <SliderColorPicker
            geometryType={
              toolState.selectedFeature === 'Marker'
                ? 'Point'
                : toolState.selectedFeature === 'Circle'
                ? 'Polygon'
                : toolState.selectedFeature
            }
            selectedSymbology={toolState.layerStyleToSave}
            onSelect={(style) =>
              toolDispatch({
                type: 'setLayerStyleToSave',
                payload: style,
              })
            }
          />
          <p style={{ marginLeft: 9 }}>
            Após salvar o desenho não será permitido editá-lo.
          </p>
          <div style={{ margin: '32px auto 0', width: '185.14px' }}>
            <Button
              variant="contained"
              color="primary"
              component="div"
              onClick={() => {
                toolDispatch({
                  type: 'saveAsLayer',
                  payload: {
                    mapContext: mapCtx,
                    callback: ({ error }) => {
                      if (!error) {
                        setIsActive(false);
                        setAnchorToolOptions(null);
                      }
                    },
                  },
                });
              }}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </SimpleModal>
    </Wrap>
  );
};

Draw.properties = {
  id: 'CPN-TB-D-DRAW',
  alias: 'Desenhar Geometria',
  description:
    'Insere geometrias do tipo linha, ponto ou polígono, também tem a opção de inserir círculo.',
  configurable: true,
};

export default Draw;
